import TemplateContext from './TemplateContext';

const TemplateProvider = ({ children, data = {} }) => {
    return (
        <TemplateContext.Provider value={data}>
            {children}
        </TemplateContext.Provider>
    )
}
export default TemplateProvider;